<div class="cf">
  <a
    href="{{ link().url }}"
    class="btn btn--arrow nordic-blue-900-bg surface-contrast white-text text-icon-reversed pr-xsmall col-1-1"
    rel="noopener noreferrer"
    target="_blank"
  >
    {{ link().text }}
  </a>
</div>
